import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputMask from "react-input-mask";
import { DatePicker } from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import ruLocale from "date-fns/locale/ru";
import { CircularProgress, Grid, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFilials } from "../../../redux/actions/filialActions";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    bgcolor: 'background.paper',
    border: '3px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function EditResultForm({ action, title, open, setOpen, onSubmit }) {
    const dispatch = useDispatch();
    const [id, setId] = useState(null);
    const [number, setNumber] = useState('');
    const [createdAt, setCreatedAt] = useState(new Date());
    const [schema, setSchema] = useState('');
    const [filialId, setFilialId] = useState(null);
    const { loading, resultForms, resultForm } = useSelector((state) => state.resultForm);
    const { filials, filialRequestedCount } = useSelector((state) => state.filial);
    const emptyState = () => {
        setId(null);
        setNumber('');
        setCreatedAt(new Date());
        setSchema('');
        setFilialId(null);
    };
    const handleForm = async (e) => {
        e.preventDefault();
        onSubmit({ id, number, createdAt, schema, filialId });
        setOpen(false);
        emptyState();
    };
    const handleClose = async () => {
        setOpen(false);
        emptyState();
    };
    useEffect(() => {
        const {
            id, number, createdAt, schema, filialId
        } = resultForm || {};
        setId(id);
        setNumber(number);
        setCreatedAt(createdAt);
        setSchema(schema);
        setFilialId(filialId);
    }, [resultForm, resultForms])
    useEffect(() => {
        if (!open)
        {
            return;
        }
        let response;
        const getFilialsAsync = async () => {
            response = await dispatch(getFilials({ paging: { skip: 0 } }));
        }
        if (filialRequestedCount == 0)
        {
            getFilialsAsync();
        }
    }, [dispatch, action])
    return (
        <div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
                {loading ? <CircularProgress/> :
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            {title}
                        </Typography>
                        <Box component="form" onSubmit={handleForm} sx={{mt: 1, display: 'flex', flexWrap: 'wrap'}}>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField margin="normal" required value={number} onChange={(e) => setNumber(e.target.value)} fullWidth id="number" name="number" label="Номер" />
                                </Grid>
                                <Grid item xs={6}>
                                    <LocalizationProvider locale={ruLocale} dateAdapter={AdapterDateFns}>
                                        <DatePicker views={['day']} label="Создано" value={createdAt} onChange={(newValue) => {
                                            setCreatedAt(newValue);
                                        }}  renderInput={(params) =>
                                            <TextField margin="normal"  {...params} helperText={null}/>
                                        }/>
                                    </LocalizationProvider>
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField margin="normal" required value={schema} onChange={(e) => setSchema(e.target.value)} fullWidth id="schema" name="schema" label="Форма" />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField  value={filialId} onChange={(e) => setFilialId(e.target.value)} margin="normal" fullWidth id="filialId" select>
                                        {filials && filials.map(_ => (
                                            <MenuItem key={_.id} value={_.id}>
                                                {_.name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                                {action != 'details' && 
                                    <Grid item xs={6}>
                                        <Button type="submit" fullWidth variant="contained" sx={{mt: 3, mb: 2}}>
                                            {'Сохранить'}
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Box>
                    </Box>
                }
            </Modal>
        </div>
    )
}
